import BaseApiService from '../base/BaseApiService';
import type { Role } from '@app-types';

class RolesService extends BaseApiService {
  /**
   * Get all roles
   */
  async getRoles(): Promise<Role[]> {
    const response = await this.get<{ success: boolean; data: Role[] }>('/roles');
    return response.data;
  }

  /**
   * Get role by ID
   */
  async getRoleById(id: number): Promise<Role> {
    const response = await this.get<{ success: boolean; data: Role }>(`/roles/${id}`);
    return response.data;
  }
}

const rolesService = new RolesService();
export default rolesService;
